import uiRouter from 'angular-ui-router';
import { contactusDirective } from './contactus.directive';
import { contactusStore } from './contactus.store';

export const contactus = angular
  .module('contactus', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.contactus', {
      url: '/CustContactStep1.aspx',
      template: '<contactus></contactus>',
      data: {
        metaTitle: 'Rentaskip Australia | Contact us',
        metaDescription:
          'Phone numbers and email contacts and hours of operation',
        metaKeywords: 'Skip hire, contact us'
      }
    });
  })
  .directive('contactus', contactusDirective)
  .factory('contactusStore', contactusStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/contactus/contactus.js
 **/